import { Avatar, Button, Link } from '@mui/material'

import { LinkIcon } from 'src/assets/icons'
import { HelperWrapper } from '../helper-wrapper'
import { useStyles } from './styles'

interface IProps {
  image?: string | null
}

export const ImageField = ({ image }: IProps) => {
  const classes = useStyles({})

  if (!image) {
    return null
  }

  return (
    <div className={classes.imageWrapper}>
      <Avatar style={{ height: 140, width: 140 }} variant="rounded" src={image} />
    </div>
  )
}
